import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import { PDFDownloadLink } from '@react-pdf/renderer';
import InvoicePDF from './InvoicePDF';
import UserInvoiceStructure from './user-invoice-structure';

const UserInvoiceView = () => {
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const invoiceData = {
        invoiceNumber: '3682303',
        date: '03/10/2018',
        dueDate: '03/11/2018',
        companyInfo: {
            name: 'MasjidHub',
            address: '45 Roker Terrace, Latheronwheel, KW5 8NW, London, United Kingdom',
        },
        billTo: {
            name: 'Sara Williams',
            address: '280 Suzanne Throughway, Breannabury, OR 45801, United States',
        },
        items: [
            {
                description: 'Design UX and UI',
                qty: 1,
                rate: 5,
                amount: 500,
            },
            {
                description: 'Web project',
                qty: 1,
                rate: 24,
                amount: 1250,
            },
            {
                description: 'SEO',
                qty: 1,
                rate: 6,
                amount: 2000,
            },
        ],
        subtotal: 2750,
        tax: 39,
        total: 2750,
        amountPaid: 2789,
        dueBalance: 0,
    };

    const handleInvoiceClick = () => {
        navigate('/user-dashboard/invoice-pdf', { state: { invoiceData } });
    };

    const handleOpen = () => {
        setOpen(true);
    };

    // Close the modal
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 py-10 mx-auto bg-gray-50">
                <div className="sm:w-11/12 lg:w-3/4 mx-auto">

                    {/* Buttons */}
                    <div className="mb-6 flex justify-end gap-x-3">

                        <button
                            onClick={handleOpen}
                            className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-50 dark:bg-transparent dark:border-neutral-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
                        >
                            View Invoice
                        </button>


                        {/* PDF Download Link */}
                        <PDFDownloadLink document={<InvoicePDF invoiceData={invoiceData} />} fileName="invoice.pdf">
                            {({ loading }) => (
                                <button
                                    className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
                                >
                                    {loading ? 'Loading...' : 'Download PDF'}
                                </button>
                            )}
                        </PDFDownloadLink>
                    </div>


                    <UserInvoiceStructure invoiceData={invoiceData} />
                </div>

                {open && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                        {/* Modal container */}
                        <div className="bg-white w-full h-full p-0 overflow-auto flex flex-col">
                            <div className="flex justify-between items-center p-3">
                                <h2 className="text-xl">Invoice PDF</h2>
                                <button
                                    onClick={handleClose}
                                    className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-gray-800 text-gray-50"
                                >
                                    Close
                                </button>
                            </div>

                            {/* PDFViewer to render the invoice */}
                            <div className="flex-grow">
                                <PDFViewer width="100%" height="100%">
                                    <InvoicePDF invoiceData={invoiceData} />
                                </PDFViewer>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default UserInvoiceView;